import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { Account } from "../";
/**
* @class CheckingAccount
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.checkingAccount[0];
* const checking = new CheckingAccount(record);
* @property {NUMBER} _mapID - used to map checking account information with account data
* @property {bcmsCurrency} _availableBalance - balance available in the account
* @property {STRING} _interestRate - place holder for showing the interest rate for the account
* @property {STRING} _ytdInterest - dollar amount of interest paid for year
* @property {bcmsCurrency} _currentBalance - The current balance of the account
*/
   
export default class CheckingAccount extends BCMSRecord{

    _mapID;   
    _availableBalance;  
    _interestRate;   
    _ytdInterest;
    _currentBalance;

    constructor (record){   
      super(Object.assign(record,Account.initByID(record.mapID).record)) 
    }    

    /** 
    * @function initAll   
    * @static
    * @property {VOID} - No parameters
    * @description Returns all accounts with branding option "Show Business Accounts" 
    * (action script name: show_business_accounts_abi22) applied.
    * @example const accounts = CheckingAccount.initAll();
    * @memberof CheckingAccount 
    */
    static initAll() {
      const { options } = this._GlobalController.state.branding;
      const showBusinessAccounts = options.show_business_accounts_abi22 === "true";

      const filterByBusinessValue = item => {
        if(showBusinessAccounts) {
          return true;
        } else {
          if(item.isBusiness === "true") {
            return false;
          }
        }
        return true;
      }

      const accounts = this._GlobalController.state[this._RecordType]

      return accounts.map((record) => {
          return Account.initByType(record.mapID);
      }).filter(filterByBusinessValue);
    }
  }   
  CheckingAccount.define({
    "recordType":"checkingAccounts",
    "recordIDProp":"mapID",
    "className" : "CheckingAccount",
    "recordProperties": [
      /** 
      * @name mapID
      * @instance
      * @property get {NUMBER} - gets the mapID of the checkingAccount
      * @property set {NUMBER} - sets the imapIDd of the checkingAccount
      * @memberof CheckingAccount 
      */
      BCMSRecordProperty.mapToNumber("mapID","_mapID"),
      /** 
      * @name availableBalance
      * @instance
      * @property get {bcmsCurrency} - gets the availableBalance of the checkingAccount
      * @property set {bcmsCurrency} - sets the availableBalance of the checkingAccount
      * @memberof CheckingAccount 
      */
      BCMSRecordProperty.mapToCurrency("availableBalance","_availableBalance"),
      /** 
      * @name interestRate
      * @instance
      * @property get {STRING} - gets the interestRate of the checkingAccount
      * @property set {STRING} - sets the interestRate of the checkingAccount
      * @memberof CheckingAccount 
      */
      BCMSRecordProperty.mapToString("interestRate","_interestRate"),
      /** 
      * @name ytdInterest
      * @instance
      * @property get {STRING} - gets the ytdInterest of the checkingAccount
      * @property set {STRING} - sets the ytdInterest of the checkingAccount
      * @memberof CheckingAccount 
      */
      BCMSRecordProperty.mapToString("ytdInterest","_ytdInterest"),

      /**
       * @name currentBalance
       * @instance
       * @property get {bcmsCurrency} - gets the currentBalance of the checkingAccount
       * @property set {bcmsCurrency} - sets the currentBalance of the checkingAccount
       * @memberof CheckingAccount
       */
      BCMSRecordProperty.mapToCurrency("currentBalance", "_currentBalance")
    ].concat(Account._RecordProperties)
})




